import { IRecommendedPackage } from '../../../../../../../../types/reducers/recommendedPackages';

interface ITrackingData {
  id: number | undefined;
  cnt: number;
  name: string;
  price: number;
  discount: number;
  type: string;
}

export const mapPackageTrackingData = (recommendedPackage: IRecommendedPackage): ITrackingData => ({
  id: recommendedPackage.packageId,
  cnt: recommendedPackage.totalPublicationCount,
  name: recommendedPackage.headerText,
  price: recommendedPackage.price,
  discount: recommendedPackage.discountPercent,
  type: recommendedPackage.type,
});
